import { useState, useEffect, useRef } from 'react'
import { dispatchSocket } from '@/utils/socket'
import type { DispatchUpdatedEvent, DispatchEmitPayload } from '@/types'

export const useDispatchSocket = () => {
  const [lastDispatchMessage, setLastDispatchMessage] = useState<DispatchUpdatedEvent | null>(null)
  const dispatchCallbacksRef = useRef<Set<(data: DispatchUpdatedEvent) => void>>(new Set())

  useEffect(() => {
    const unsubUpdated = dispatchSocket.on<DispatchUpdatedEvent>('dispatchUpdated', (data) => {
      console.log('🔄 dispatchUpdated reçu:', data)
      setLastDispatchMessage(data)
      dispatchCallbacksRef.current.forEach(callback => {
        try {
          callback(data)
        } catch (error) {
          console.error('❌ Erreur dans callback dispatch:', error)
        }
      })
    })

    return () => {
      unsubUpdated()
    }
  }, [])

  const onDispatchUpdate = (callback: (data: DispatchUpdatedEvent) => void): (() => void) => {
    dispatchCallbacksRef.current.add(callback)
    return () => {
      dispatchCallbacksRef.current.delete(callback)
    }
  }

  return {
    lastDispatchMessage,
    onDispatchUpdate,
  }
}

export const useDispatchEmit = () => {
  const emitDispatchUpdate = (data: DispatchEmitPayload) => {
    dispatchSocket.emit('dispatchUpdate', data)
  }

  return {
    emitDispatchUpdate,
  }
}
